{
  "certificates": {
    "kpiConnector": "Conector KPI",
    "trustore": "Truststore",
    "s4Device": "Equipos S4",
    "s4ToolsApp": "Aplicaciones S4-Tools",
    "s4ManagerApp": "Aplicaciones S4-Manager",
    "s4ViewApp": "Aplicaciones S4-View",
    "sg4000": "Aplicaciones SG4000",
    "requiredFields": "Los campos precedidos de * son obligatorios.",
    "delayInfo": "El período de renovación automática define el período previo a la fecha de caducidad del certificado a partir de la que se activa automáticamente el procedimiento de renovación del certificado.",
    "delayPlaceholder": "Período de renovación automática",
    "delayPlaceholderCustom": "Período de renovación automática (en días)",
    "pollingPlaceholder": "Frecuencia de polling (minutos)",
    "pollingInfoDevice": "La frecuencia de polling se corresponde con el período entre dos intercambios entre LX CONNECT y el equipo.",
    "pollingInfoApplication": "La frecuencia de polling se corresponde con el período entre dos intercambios entre LX CONNECT y la aplicación.",
    "autoActivationLabel": "Activación automática",
    "autoActivationAction": "Activar",
    "autoActivationInfoApplication": "La activación automática permite activar la aplicación en el momento del suministro.",
    "autoActivationInfoDevice": "La activación automática permite activar el equipo en el momento del suministro.",
    "title": "Certificados"
  },
  "firmware": {
    "title": "Firmware",
    "firmwareManagement": "Gestión de los firmwares"
  },
  "users": {
    "title": "Usuarios",
    "activeDirectory": "Active Directory"
  },
  "application": {
    "title": "Configuración de la aplicación",
    "smtpServor": "Servidor SMTP",
    "feelAndIdentity": "Aspecto e identidad"
  },
  "applicationMgt": {
    "title": "Aplicaciones",
    "applicationManagement": "Gestión de las aplicaciones"
  },
  "usersPreference": {
    "title": "Preferencias del usuario",
    "userParams": "Ajustes del usuario"
  },
  "technicalVersion": {
    "label": "Versión técnica:",
    "unknown": "desconocida"
  },
  "version": {
    "label": "Versión:",
    "unknown": "desconocida"
  },
  "platformMgt": {
    "title": "Plataforma",
    "about": "Acerca de"
  },
  "deviceConfiguration": "Configuración de los equipos"
}
